import { render } from "./NavbarNotifications.vue?vue&type=template&id=ee51894e"
import script from "./NavbarNotifications.vue?vue&type=script&lang=js"
export * from "./NavbarNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__